import { HttpInterceptorFn } from '@angular/common/http';

// Empty, not used atm.
export const generalHttpInterceptor: HttpInterceptorFn = (
  req: any,
  next: any
) => {
  // console.log('req: ', req);
  /*
  req = req.clone({
    setHeaders: {
      'Access-Control-Allow-Headers':'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Icy-Metadata, mode, accept, Content-Type',
      'Access-Control-Allow-Methods': 'GET, OPTIONS',
      'Access-Control-Allow-Origin': '*',
      'Icy-Metadata': '1',
    },
  });
  */
  return next(req);
};
